import { z } from "zod/v4";

export const ShippingTestMethodDefinitionDtoSchema = z.object({
  id: z.uuid().optional(),
  deliveryProfileId: z.string(),
  deliveryLocationGroupId: z.string(),
  deliveryZoneId: z.string(),
  methodDefinitionId: z.string().nullish(),
});

export type ShippingTestMethodDefinitionDto = z.infer<
  typeof ShippingTestMethodDefinitionDtoSchema
>;
